import React, { useState } from "react";
import swal from "sweetalert";

const Form = () => {
  const [fullName, setFullName] = useState("");
  const [messageTitle, setMessageTitle] = useState("");
  const [messageContent, setMessageContent] = useState("");
  const [email, setEmail] = useState("");

  const [formData, setFormData] = useState({
    name: fullName,
    email: email,
    msg_title: messageTitle,
    msg: messageContent,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://form-api-vm0g.onrender.com/mail/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        // mode: "cors",
        redirect: "follow",
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      alert("Successful");
      console.log(result.message);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const inputFields = [
    {
      id: 1,
      placeholder: "Enter Your Full Name",
      value: fullName,
      alter: setFullName,
    },
    {
      id: 2,
      placeholder: "Enter Your Email Address",
      value: email,
      alter: setEmail,
    },
    {
      id: 3,
      placeholder: "Enter Your Message Title",
      value: messageTitle,
      alter: setMessageTitle,
    },
  ];

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col space-y-7 mx-auto bg-white rounded-xl px-2 py-10 shadow-xl w-11/12 lg:w-1/2 lg:px-6"
    >
      {inputFields.map((input) => (
        <input
          key={input.id}
          type="text"
          className="px-4 py-2 border-darkBlue border-opacity-50 rounded-lg border w-full focus:outline-brandPrimary"
          placeholder={input.placeholder}
          onChange={(e) => {
            input.alter(e.target.value);
          }}
          value={input.value}
        />
      ))}
      <textarea
        name="messageContent"
        id="messageContent"
        cols="30"
        rows="10"
        placeholder="Enter your Message"
        value={messageContent}
        onChange={(e) => {
          setMessageContent(e.target.value);
        }}
        className="px-4 py-2 border-darkBlue border-opacity-50 rounded-lg border w-full focus:outline-brandPrimary"
      ></textarea>
      <button
        type="submit"
        className="w-full py-2 bg-brandPrimary flex justify-center items-center rounded-lg text-white"
      >
        Send Message
      </button>
    </form>
  );
};

export default Form;

// const formdata = new FormData();
// formdata.append("name", encodeURIComponent(fullName));
// formdata.append("email", encodeURIComponent(email));
// formdata.append("msg_title", encodeURIComponent(messageTitle));
// formdata.append("msg", encodeURIComponent(messageContent));

// const requestOptions = {
//   method: "POST",
//   body: formdata,
//   redirect: "follow",
// };

// fetch("https://form-api-vm0g.onrender.com/mail", requestOptions)
//   .then((response) => {
//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }
//     return response.text();
//   })
//   .then((result) =>
//     swal("Success!", "Message Sent Successfully!", "success")
//   )
//   .catch((error) => console.error("Error:", error));

// alert(`My name is ${fullName} i have ${messageContent}`)
